import { FormattedMessage } from 'react-intl'
import Info from 'components/shared/Info'
import { Wrapper } from './styles'
import { DefaultTheme } from 'styled-components'

interface TimeBetweenTripsWarningProps {
    theme?: DefaultTheme
}

export const TimeBetweenTripsWarning = ({
    theme,
}: TimeBetweenTripsWarningProps) => {
    const hasDarkMode = theme?.mode === 'dark'

    return (
        <Wrapper isFullWidth mt={16} pb={0} theme={theme}>
            <Info
                color="info"
                hasNoBackground={hasDarkMode}
                hasBorder={hasDarkMode}
            >
                <FormattedMessage
                    id="upsells.msg.bus_requirements_warning"
                    defaultMessage="Czas pomiędzy kursami jest za krótki. Aby zdążyć na kurs powrotny, wybierz inną godzinę odjazdu."
                />
            </Info>
        </Wrapper>
    )
}
